import { useMediaQuery, useTheme } from "@mui/material";
import PageSection from "@/common/page-section.common";
import { Card } from "./card.component";
import ApplicationIcon from "./icons/application-icon.component";
import ReceiveIcon from "./icons/receive-icon.component";
import RegisterIcon from "./icons/register-icon.component";
import TrackIcon from "./icons/track-icon.component";

export const HowItWorks = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
  return (
    <PageSection dull heading="How It Works">
      <div 
        className="
          w-full grid grid-cols-2 justify-items-center sm:flex sm:flex-wrap 
          sm:justify-center items-center gap-4 sm:gap-8 sm:px-0
        "
      >
        <div className="flex justify-center w-full sm:w-auto sm:flex-1">
          <Card
            text="Register & Create Account"
            subText="Create your account with basic details and verify your email address"
          >
            <RegisterIcon />
          </Card>
        </div>
        <div className="flex justify-center w-full sm:w-auto sm:flex-1">
          <Card
            text="Submit Application"
            subText="Fill the application form and upload all required documents"
          >
            <ApplicationIcon />
          </Card>
        </div>
        <div className="flex justify-center w-full sm:w-auto sm:flex-1">
          <Card
            text="Track Status"
            subText="Monitor your application status in real-time through the portal"
          >
            <TrackIcon />
          </Card>
        </div>
        <div className="flex justify-center w-full sm:w-auto sm:flex-1">
          <Card
            text="Receive Decision"
            subText="Get notified about the final decision on your application"
          >
            <ReceiveIcon />
          </Card>
        </div>
      </div>
    </PageSection>
  );
};

export default HowItWorks;